/* DataExplorerLmrbComponent.js */

"use strict";
const GameEditor = require("@gluenetworks/game_editor");
const Registrations = require("../../../RegistrationNamespaces");
const Steve = require("@gluenetworks/steve_core").getInstance();
const _ = require("lodash");

class DataExplorerLmrbComponent extends GameEditor {
    constructor(logger, di, editorLayout, userSession, solutionManager, storageFactory) {
        super(logger, di);

        this._editorLayout = editorLayout;
        this._userSession = userSession;
        this._solutionManager = solutionManager;
        this._storageFactory = storageFactory;
        this._updateNameSpaces();
        this._registerDataExplorerListeners();

        this._activeOrgId = _.get(this._userSession, "activeOrganization.id");
        let superRender = this.renderer.render;
        this.renderer.render = (args) => {
            return superRender.apply(this.renderer, args).then(() => {
                this.renderer.rootElement.classList.add("data-explorer-lmrb");
                return this.whenGameEditorStorageIsReady().then(() => {
                    let otherParams = _.get(Steve.router.getRouteDetails(), "rd", "");
                    if (otherParams.openEditor || !_.isEmpty(otherParams.selection)) {
                        this._openEditorFromUrl = {
                            open: otherParams.openEditor || false,
                            selectedIds: otherParams.selection,
                        };
                    }
                    if (!_.isEmpty(otherParams.filter)) {
                        this._filterFromUrl = true;
                    }
                    if (_.isEmpty(otherParams.filter) && !_.isUndefined(otherParams.filter)) {
                        this._emptyFilter = true;
                    }

                    if (this._LMRBLayout.state.bottom.dockletClicked === true) {
                        this._gameEditorData.setData(
                            this._LMRBLayout.state.bottom._state.openedPartId,
                            "currentExplorerView"
                        );
                        this._LMRBLayout.state.bottom.dockletClicked = undefined;
                    }

                    const currentView = this._whereToRedirect();
                    this._switchSolution(currentView);

                    return;
                });
            });
        };
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    whenInitialized() {
        return Promise.resolve().then(() => {
            if (!Steve.controlAppNav.xDomeEnabled) {
                this.hideBarView(Registrations.DATA_EXPLORER_SWITCH_TO_IOT_DEVICE_EXPLORER);
                this._LMRBLayout.state.bottom.removePart(
                    Registrations.DATA_EXPLORER_IOT_DEVICE_EXPLORER_ENTITY_LMRB
                );
            }

            return Promise.resolve();
        });
    }

    _updateNameSpaces(withUpdate) {
        let solutionDefinition = this._solutionManager.getActiveSolution();
        let gameEditorViews = _.get(solutionDefinition, "dataExplorer.viewNamespaces", []);
        let gameEditorActions = [];
        if (
            _.get(this._userSession, "authorizedActions", []).indexOf("explorerTemplateWrite") >= 0
        ) {
            //actions if perm available
            gameEditorActions = gameEditorActions.concat(
                _.get(solutionDefinition, "dataExplorer.actionNamespaces", [])
            );
        }

        this.setNamespaceGlobs(gameEditorViews.concat(gameEditorActions), !withUpdate);

        this.enableAllActions();
    }

    _whereToRedirect() {
        let currentView = "";

        if (_.get(Steve.router.getRouteDetails(), "exp", false)) {
            let currentViewName = _.get(Steve.router.getRouteDetails(), "exp", "");

            switch (currentViewName) {
                case "device":
                    currentView = Registrations.DATA_EXPLORER_DEVICE_EXPLORER_ENTITY_LMRB;
                    break;
                case "iot_device":
                    currentView =
                        Steve.controlAppNav && Steve.controlAppNav.xDomeEnabled
                            ? Registrations.DATA_EXPLORER_IOT_DEVICE_EXPLORER_ENTITY_LMRB
                            : Registrations.DATA_EXPLORER_DEVICE_EXPLORER_ENTITY_LMRB;
                    break;
                default:
                    currentView = Registrations.DATA_EXPLORER_LMRB;
                    break;
            }
        }

        return currentView;
    }

    _registerDataExplorerListeners() {
        this._solutionManager.on(
            "activeSolutionChanged",
            (this._onSolutionChanged = this._onSolutionChanged.bind(this))
        );
        this._userSession.on(
            "OrganizationChange",
            (this._onOrganizationChange = this._onOrganizationChange.bind(this))
        );

        this._cabinetCmpnt.on(
            "ExplorerChanged",
            (this._onExplorerChanged = this._onExplorerChanged.bind(this))
        );
        Steve.router.on(
            "RouteDetailsChanged",
            (this._onRouteInfoChanged = _.throttle(this._onRouteInfoChanged.bind(this), 500))
        );
    }

    _unregisterDataExplorerListeners() {
        if (this._solutionManager) {
            this._solutionManager.removeListener("activeSolutionChanged", this._onSolutionChanged);
        }
        if (this._userSession) {
            this._userSession.removeListener("OrganizationChange", this._onOrganizationChange);
        }
        if (this._cabinetCmpnt) {
            this._cabinetCmpnt.removeListener("ExplorerChanged", this._onExplorerChanged);
        }
        if (Steve.router) {
            Steve.router.removeListener("RouteDetailsChanged", this._onRouteInfoChanged);
        }
    }

    launchDataExplorerEditor(editorState, launchOpts) {
        const {id, ids} = launchOpts;
        // console.log(ids);
        launchOpts = _.assign({}, launchOpts, {
            id: id ? id : ids ? ids[0] : "",
            ids: ids ? ids : [id],
        });
        return this._editorLayout.launchEditor(
            editorState,
            Registrations.DATA_INSTANCE_EDITOR,
            launchOpts
        );
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    shutdown() {
        let shutdowns = [
            _.invoke(this._statusBar, "shutdown"),
            _.invoke(this._imageServersFeed, "shutdown"),
        ];
        return Promise.all(shutdowns).then(
            () => {
                this._unregisterDataExplorerListeners();
                this._editorLayout = undefined;
                this._userSession = undefined;
                this._solutionManager = undefined;
                this._openEditorFromUrl = undefined;
                this._filterFromUrl = undefined;
                this._emptyFilter = undefined;
                return super.shutdown();
            },
            (err) => {
                this._logger.warn(
                    {error: err},
                    "OSPlanExplorerEntityLmrbComponent.shutdown() error"
                );
            }
        );
    }

    /**
     * On a first visit, reopen previously opened solution
     */
    _switchSolution(view = "") {
        let currentExplorerView = this._gameEditorData.getData("currentExplorerView");
        if (!_.isEmpty(view)) {
            currentExplorerView = view;
        }
        this._gameEditorData.setData(currentExplorerView, "currentExplorerViewTemp");

        if (
            currentExplorerView &&
            currentExplorerView === Registrations.DATA_EXPLORER_DEVICE_EXPLORER_ENTITY_LMRB
        ) {
            this.openLMRBExplorer(Registrations.DATA_EXPLORER_DEVICE_EXPLORER_ENTITY_LMRB);
        } else if (
            currentExplorerView &&
            currentExplorerView === Registrations.DATA_EXPLORER_IOT_DEVICE_EXPLORER_ENTITY_LMRB
        ) {
            this.openLMRBExplorer(Registrations.DATA_EXPLORER_IOT_DEVICE_EXPLORER_ENTITY_LMRB);
        } else if (
            currentExplorerView &&
            currentExplorerView === Registrations.DEVICE_EXPLORER_ENTITY_LMRB
        ) {
            this.openLMRBExplorer(Registrations.DEVICE_EXPLORER_ENTITY_LMRB);
        } else {
            this.openLMRBExplorer(Registrations.DATA_EXPLORER_LMRB);
            this._cabinetCmpnt.selectView(Registrations.DATA_EXPLORER_GRID);
        }

        return;
    }

    /*******************************************/
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onSolutionChanged(/*newActiveSolution*/) {
        // Case 22070 -- removing the condition and shutting down always
        // if (
        //     newActiveSolution.lmrbNamespaces &&
        //     newActiveSolution.lmrbNamespaces.includes(Registrations.FILE_EXPLORER_LMRB)
        // ) {
        // this._updateNameSpaces(true);
        //     this.renderer.render();
        // } else {
        this.shutdown();
        // }
    }

    _onOrganizationChange(newOrg, oldOrg) {
        if (!_.isUndefined(newOrg) && !_.isUndefined(oldOrg) && newOrg.id !== oldOrg.id) {
            this._updateNameSpaces(true);
            this.renderer.render();
        }
    }

    _onExplorerChanged() {
        this.shutdown();
    }

    _onRouteInfoChanged() {
        if (event && event.oldURL !== event.newURL) {
            const currentView = this._whereToRedirect();
            if (
                currentView &&
                this._gameEditorData.getData("currentExplorerViewTemp") !== currentView
            ) {
                this._gameEditorData.setData(currentView, "currentExplorerViewTemp");
                this._gameEditorData.setData(currentView, "currentExplorerView");
                // Don't emit ExplorerChanged here - openLMRBExplorer handles the view switching
                // Emitting it causes double shutdown of the current view
                this.openLMRBExplorer(currentView);
            }
        }
    }
}

module.exports = DataExplorerLmrbComponent;

DataExplorerLmrbComponent.$inject = [
    "$teve.logger",
    "$teve.di",
    "EditorLayout.EditorLayout",
    "$teve.userSession",
    "$teve.solutionsManager",
    "$teve.storageFactory",
];
DataExplorerLmrbComponent.$supportedQuadrants = ["bottom"];
DataExplorerLmrbComponent.$defaultQuadrants = ["bottom"];
DataExplorerLmrbComponent.$iconRepoName = "dataexplorer.detailed";
DataExplorerLmrbComponent.$openedByDefault = true;
DataExplorerLmrbComponent.$displayName = "Template Library";
